(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-collection"]) return;
  try {
    
$(document).ready(function() {
  if ($('.slides').length > 0) {
    $('.slides').each(function() {
      $(this).slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        fade: false,
        dots: false,
        arrows: true,
        centerMode: true,
        variableWidth: true,
        prevArrow: '<span class="prev"></span>',
        nextArrow: '<span class="next"></span>',
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
